// ============================================================
// api/adminDeletionRequests.js — the A2Z IT half of the C4 deletion-request
// workflow (first UI 2026-08-20; the endpoints shipped 2026-08-15).
//
// Backend reference:
//   backend/func-carehub-api/src/functions/admin-deletion-requests.js
//
// NOTHING HERE DELETES DATA. Review is approve/reject only; an approved
// deletion is carried out MANUALLY by A2Z IT and then recorded with
// mark-actioned. The handler family contains no DELETE by design.
// ============================================================

import { apiGet, apiPost } from './client';

// Paths are relative to the API base and must NOT carry an `/api` prefix —
// the client adds it (the doubled-prefix class that shipped six dead admin
// surfaces on 2026-08-04).

/**
 * The review queue, OLDEST first (worked top-down, so truncation drops the
 * NEWEST — the ordering-accurate truncation rule).
 * @param {Object} [params={}]
 * @param {string} [params.status] pending|approved|rejected
 */
export function listAdminDeletionRequests(params = {}) {
  const qs = new URLSearchParams();
  if (params.status) qs.set('status', params.status);
  const q = qs.toString();
  return apiGet(`/mgmt/admin/deletion-requests${q ? `?${q}` : ''}`);
}

/**
 * One-shot review of a PENDING request (409 otherwise).
 * A rejection MUST carry notes — the server 400s without them.
 */
export function reviewAdminDeletionRequest(deletionRequestId, decision, notes) {
  return apiPost(`/mgmt/admin/deletion-requests/${deletionRequestId}/review`, {
    decision,
    ...(notes ? { notes } : {}),
  });
}

/**
 * Record that the manual deletion of an APPROVED request has been carried
 * out. Once-only (409 on repeat or on a non-approved request).
 */
export function markAdminDeletionRequestActioned(deletionRequestId) {
  return apiPost(`/mgmt/admin/deletion-requests/${deletionRequestId}/mark-actioned`, {});
}
